import React, { FC } from 'react'
import { Link, useLocation } from 'react-router-dom'
import ROUTES from '../utils/routes'
import { Styled404 } from '.'

type StateType = {
  message?: string;
  backUrl?: string;
}

const FourOhFour: FC = () => {
  const { state }: { state: StateType } = useLocation()
  return (
    <Styled404>
      <h1>404 - Not Found</h1>
      {state?.message && (
        <div className="message">{state?.message}</div>
      )}
      <Link to={state?.backUrl || ROUTES.dashboard.home}>Go Back</Link>
      {/* if not logged in, direct user to login page */}
      {/* elseif logged in, direct user to dashboard */}
    </Styled404>
  )
}

export default FourOhFour
